import React from 'react';
import { CORRECTIONS } from '../shared/ToolbarConstants';
import { URL } from './ApiConstants';

export const LOW_TEXT = 'Low Text';
export const HIGH_TEXT = 'High Text';
export const ON_GRADE_TEXT = 'On-Grade Text';
export const CHANGED_PERFOMANCE_MODAL = 'CHANGED_PERFOMANCE_MODAL';
export const ADDITIONAL_BOOK_MODAL = 'ADDITIONAL_BOOK_MODAL';
export const REVERT_MODAL = 'REVERT_MODAL';
export const UNTRANSCRIBABLE_MODAL = 'UNTRANSCRIBABLE_MODAL';
export const NOT_SCORED = 'Not Scored';
export const SUMMARY_TABLE_TITLE = 'Select a book to see the details below';
export const CANNOT_BE_EDIT_MESSAGE = (
    <>
        These results cannot be edited. Please see the{' '}
        <a className="anchor" href={URL.ONLINE_HELP} target="_blank" rel="noreferrer noopener">
            online Help
        </a>{' '}
        for a detailed explanation of the results editing tool and a description of why certain
        results cannot be edited.
    </>
);
export const TRO_EOY_CAN_EDIT_TEXT = <>Results can be edited until the end of the school year</>;
export const ENTER_END_TIME_MESSAGE =
    'Enter the timestamp from the audio player to mark the last word read.';

export const TRO_UNTRANSCRIBABLE_CELL = <div className="score-interp">{NOT_SCORED}</div>;

export const TRO_BANNER_CONTENT = {
    UNTRANSCRIBABLE_BANNER:
        'Listen to the audio file, then select the last word read by the student.',
    ON_GRADE_TEXT_BANNER:
        'Your edits may cause score changes that may require this student to complete another TRO book.',
    HIGH_OR_LOW_TEXT_BANNER:
        'Editing the Reading Transcript may result in changes to the student’s final score.',
};

export const READING_STATS_LABELS = {
    insertions: 'Insertion',
    correctWords: 'Correct Words',
    omissions: 'Omission',
    subtitutions: 'Substitution',
};

export const LEGEND_SECTION_READ_MODE = [
    {
        label: `INSERT`,
        shortLabel: '',
        className: 'insert',
    },
    {
        label: 'SUBSTITUTE',
        shortLabel: CORRECTIONS.SUBSTITUTE,
        className: 'sub',
    },
    {
        label: 'OMIT',
        shortLabel: CORRECTIONS.OMIT,
        className: 'omit',
    },
];

export const LEGEND_SECTION_EDIT_MODE = [
    {
        label: `INSERT (LEFT)`,
        shortLabel: CORRECTIONS.INSERT_LEFT,
        className: 'insert',
    },
    {
        label: `INSERT (RIGHT)`,
        shortLabel: CORRECTIONS.INSERT_RIGHT,
        className: 'insert',
    },
    {
        label: 'SUBSTITUTE',
        shortLabel: CORRECTIONS.SUBSTITUTE,
        className: 'sub',
    },
    {
        label: 'OMIT',
        shortLabel: CORRECTIONS.OMIT,
        className: 'omit',
    },
    {
        label: 'CORRECT',
        shortLabel: CORRECTIONS.CORRECT,
        className: 'correct',
    },
];

export const RESCORING_INSTRUCTION_TYPES = {
    COMMON_INSTRUCTION: 'COMMON_INSTRUCTION',
    NOT_SCORED_INSTRUCTION: 'NOT_SCORED_INSTRUCTION',
};

export const RESCORING_INSTRUCTION = {
    [RESCORING_INSTRUCTION_TYPES.COMMON_INSTRUCTION]: {
        TITLE: 'To edit transcript manually:',
        ITEMS: [
            'Listen to the recording and identify necessary edits.',
            'Click a word in the transcript to display the editing tool and enter your edits.',
            <>
                Click <b>Save</b> to save your changes.
            </>,
        ],
    },
    [RESCORING_INSTRUCTION_TYPES.NOT_SCORED_INSTRUCTION]: {
        TITLE: 'To edit this audio file:',
        ITEMS: [
            'Listen to the student’s recording to determine where the audio ended.',
            'In the transcript, find the last word you heard the student read. Click and hold the word until the timestamp box displays.',
            <>
                Enter the timestamp shown on the audio player in seconds and click
                <b> Save Timestamp</b>.
            </>,
            'A bracket displays on the transcript to indicate the last word the student read, and the Edit Mode for the transcript is activated.',
            'You can now make edits to the transcript.',
        ],
    },
};

export const SECONDS_REG_EXP = /^(0?[1-9]|[1-5]?\d)$/;

export const TRO_LRS_CONSTANTS = {
    FINISHED: 'Finished',
    STARTED: 'Started',
};

export const RELATIVE_LEVELS = {
    BENCHMARK: 'benchmark',
    LOW: 'low',
    HIGH: 'high',
};

export const TEXT_LEVELS_MAPPER = {
    [RELATIVE_LEVELS.LOW]: LOW_TEXT,
    [RELATIVE_LEVELS.BENCHMARK]: ON_GRADE_TEXT,
    [RELATIVE_LEVELS.HIGH]: HIGH_TEXT,
};
